import React from 'react';
import PropTypes from 'prop-types';

const Bank = ({ size, color }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 17 18"
  >
    <path
      stroke={color}
      strokeLinecap="square"
      strokeMiterlimit="10"
      d="M14.158 6.404v7.024M2.451 6.404v7.024M6.354 6.404v7.024M10.256 6.404v7.024M8.305.55.5 4.133v2.271h15.61v-2.27zM16.11 16.55H.5v-1.56c0-.863.699-1.562 1.561-1.562h12.488c.862 0 1.56.7 1.56 1.561z"
    ></path>
  </svg>
);

Bank.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string,
};

Bank.defaultProps = {
  size: 18,
  color: '#0189ED',
};

export default Bank;
